import Vue from 'vue';
import _ from "lodash";
import i18n from '../../i18n';
import paymentAPI from "../api/payment";
import { ADD_TOAST_MESSAGE } from "vuex-toast";

const types = {
    LOADING: 'LOADING',
    SET_FIELD: 'SET_FIELD',
    LOADING_BY_KEY: 'LOADING_BY_KEY',
    UPGRADE_SUCCESS: 'UPGRADE_SUCCESS',
  };

const initState = {
    form: {},
}

const getters = {
    form: state => state.form,
    loading: state => state.loading,
}

const actions = {
    setField({ commit }, { key, value }) {
        commit(types.SET_FIELD, { key, value });
    },

    async upgrade({ commit, dispatch }, payload) {
    try {
      await paymentAPI(dispatch).upgrade(payload);
      dispatch(
        ADD_TOAST_MESSAGE,
        {
          text: i18n.t('messages.upgrade_ok'),
          type: "success"
        },
        { root: true }
      );
      commit(types.UPGRADE_SUCCESS, false);
    } catch (e) {
      Vue.$log.error(i18n.t('messages.upgrade_failed'), e);
      commit('LOADING_BY_KEY', { key: "upgradeLoading", status: false });
    }
  },
}

const mutations = {
    [types.SET_FIELD](state, params) {
        Vue.set(state.form, params.key, params.value);
    },

    [types.LOADING](state, loading) {
        Vue.set(state, 'loading', loading);
    },

    [types.LOADING_BY_KEY](state, data) {
        Vue.set(state.form, data.key, data.status);
    },

    [types.UPGRADE_SUCCESS](state, data) {
        Vue.set(state, 'upgradeResult', data);
        Vue.set(state.form, 'upgradeLoading', false);
    },
}

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations
  };